export const AZUL_BOLTRACK1 = "#0F3457";
export const AZUL_BOLTRACK2 = "#18548B";